var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M6.789 29.426a1.75 1.75 0 0 1-1.002-.32 1.724 1.724 0 0 1-.672-1.952l2.648-8.569a.249.249 0 0 0-.088-.272L.69 12.977a1.727 1.727 0 0 1-.596-1.95 1.727 1.727 0 0 1 1.658-1.19h8.529a.25.25 0 0 0 .238-.176l2.605-8.427A1.72 1.72 0 0 1 14.797 0c.784 0 1.44.485 1.672 1.234l2.604 8.426a.25.25 0 0 0 .238.177h2.86a.75.75 0 0 1 0 1.5h-2.86a1.74 1.74 0 0 1-1.671-1.234l-2.605-8.426c-.09-.291-.387-.291-.476 0l-2.605 8.427a1.741 1.741 0 0 1-1.672 1.233h-8.53c-.148 0-.21.093-.235.17-.027.077-.034.189.085.277l6.984 5.337c.58.445.826 1.211.61 1.908l-2.647 8.567c-.045.144.027.231.095.279.068.047.174.085.294-.007l6.796-5.19a1.752 1.752 0 0 1 2.126 0l6.794 5.19c.118.09.226.055.295.007.069-.048.14-.135.096-.28l-2.648-8.566a1.76 1.76 0 0 1 .61-1.908l6.985-5.336c.118-.089.11-.201.085-.278a.233.233 0 0 0-.236-.17h-2.544a.75.75 0 0 1 0-1.5h2.544c.762 0 1.414.467 1.658 1.19.243.722.01 1.488-.597 1.951l-6.984 5.335a.25.25 0 0 0-.087.272l2.647 8.568a1.725 1.725 0 0 1-.671 1.953 1.728 1.728 0 0 1-2.064-.046l-6.794-5.191a.252.252 0 0 0-.304 0L7.85 29.06c-.32.244-.69.366-1.061.366"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#2A2A3A",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#636176",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9-9h48v48H-9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1bfdf2bd273912f0089925175feafc76.svg";
export { ForwardRef as ReactComponent };